export enum UnitAccountProvider {
  Choice = 0,
  Thread = 1
}

// tslint:disable-next-line:no-namespace
export namespace UnitAccountProvider {
  export function toString(provider: UnitAccountProvider): string {
    switch (provider) {
      case UnitAccountProvider.Choice:
        return 'Choice';
      case UnitAccountProvider.Thread:
        return 'Thread';
      default:
        return '';
    }
  }

  export function toProvidedBy(provider: UnitAccountProvider): string {
    switch (provider) {
      case UnitAccountProvider.Choice:
        return 'Choice Financial Group; Member FDIC';
      case UnitAccountProvider.Thread:
        return 'Thread Bank; Member FDIC';
      default:
        return '';
    }
  }

  export function parse(provider: string): UnitAccountProvider {
    return UnitAccountProvider[provider];
  }
}


export default UnitAccountProvider;
